import { render } from "./ViewList.vue?vue&type=template&id=022666a0"
import script from "./ViewList.vue?vue&type=script&lang=js"
export * from "./ViewList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\sistema-denuncias\\public\\apps\\presos-politicos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__